// Generated by scripts/build-ui-icons.mjs.
export { Detective as default } from "../ui/glyphs-3";
